import React from 'react';
import { useParams } from 'react-router';
import { OrderSummaryContainer } from './Container';
export var OrderSummaryRouted = function () {
    var params = useParams();
    var orderId = params.orderId;
    return React.createElement(OrderSummaryContainer, { orderId: orderId });
};
export default OrderSummaryRouted;
